/**
 * Storefront UI labels — predefined translations for all storefront chrome.
 * Product names/descriptions are merchant content and not translated here.
 */
const labels = {
  fr: {
    search: 'Rechercher...',
    noProducts: 'Aucun produit disponible',
    articles: 'articles',
    article: 'article',
    open: 'Ouvert',
    closed: 'Fermé',
    opensAt: 'Ouvre',
    openingHours: "Horaires d'ouverture",
    addToCart: 'Ajouter au panier',
    viewCart: 'Voir le panier',
    order: 'Commander',
    checkout: 'Paiement',
    back: 'Retour',
    loading: 'Chargement...',
    storeNotFound: 'Boutique introuvable',
    storeNotFoundDesc: "Cette boutique n'existe pas ou n'est plus disponible",
    delivery: 'Livraison',
    pickup: 'À emporter',
    dine_in: 'Sur place',
    appointment: 'Rendez-vous',
    hotel: 'Réservation',
    other: 'Autres',
    added: 'ajouté au panier',
    howToOrder: 'Comment souhaitez-vous commander ?',
    deliveryDesc: 'Recevez votre commande chez vous',
    pickupDesc: 'Récupérez en boutique',
    dine_inDesc: 'Consommation sur place',
    appointmentDesc: 'Réservez votre créneau',
    hotelDesc: 'Réservez votre séjour',
    outOfStock: 'Rupture de stock',
    address: 'Adresse',
    defaultHeroText: 'Découvrez nos produits et passez commande', myCart: 'Mon panier', emptyCart: 'Panier vide', addProductsStart: 'Ajoutez des produits pour commencer', proceedToCheckout: 'Passer à la caisse', subtotal: 'Sous-total', mon: 'Lun', tue: 'Mar', wed: 'Mer', thu: 'Jeu', fri: 'Ven', sat: 'Sam', sun: 'Dim', selectOptions: 'Sélectionnez les options requises', contact: 'Contact',
    categories: 'Catégories',
    quantity: 'Quantité',
    required: 'Requis',
    seeTranslation: 'Voir la traduction',
    seeOriginal: "Voir l'original",
    translating: 'Traduction...',
    ourAddress: 'Notre adresse',
    ourAddresses: 'Nos adresses',
    useMyLocation: 'Utiliser ma position actuelle',
    detecting: 'Détection en cours...',
    directions: 'Itinéraire',
    poweredBy: 'Propulsé par',
    mainBranch: 'Principal',
    mondayFull: 'Lundi', tuesdayFull: 'Mardi', wednesdayFull: 'Mercredi', thursdayFull: 'Jeudi', fridayFull: 'Vendredi', saturdayFull: 'Samedi', sundayFull: 'Dimanche',
    geolocationNotSupported: "La géolocalisation n'est pas supportée",
    locationDetected: 'Position actuelle détectée',
    locationError: 'Impossible de détecter votre position',
    result: 'résultat',
    results: 'résultats',
    noResults: 'Aucun résultat',
    inStock: 'en stock',
    selectOptionFirst: "Sélectionnez d'abord une option",
    addNotes: 'Ajouter des notes au produit',
  },
  en: {
    search: 'Search...',
    noProducts: 'No products available',
    articles: 'items',
    article: 'item',
    open: 'Open',
    closed: 'Closed',
    opensAt: 'Opens',
    openingHours: 'Opening hours',
    addToCart: 'Add to cart',
    viewCart: 'View cart',
    order: 'Order',
    checkout: 'Checkout',
    back: 'Back',
    loading: 'Loading...',
    storeNotFound: 'Store not found',
    storeNotFoundDesc: 'This store does not exist or is no longer available',
    delivery: 'Delivery',
    pickup: 'Pickup',
    dine_in: 'Dine in',
    appointment: 'Appointment',
    hotel: 'Reservation',
    other: 'Other',
    added: 'added to cart',
    howToOrder: 'How would you like to order?',
    deliveryDesc: 'Get your order delivered to you',
    pickupDesc: 'Pick up at the store',
    dine_inDesc: 'Eat in the restaurant',
    appointmentDesc: 'Book your time slot',
    hotelDesc: 'Book your stay',
    outOfStock: 'Out of stock',
    address: 'Address',
    defaultHeroText: 'Discover our products and place your order', myCart: 'My cart', emptyCart: 'Empty cart', addProductsStart: 'Add products to get started', proceedToCheckout: 'Proceed to checkout', subtotal: 'Subtotal', mon: 'Mon', tue: 'Tue', wed: 'Wed', thu: 'Thu', fri: 'Fri', sat: 'Sat', sun: 'Sun', selectOptions: 'Select required options', contact: 'Contact',
    categories: 'Categories',
    quantity: 'Quantity',
    required: 'Required',
    seeTranslation: 'See translation',
    seeOriginal: 'See original',
    translating: 'Translating...',
    ourAddress: 'Our address',
    ourAddresses: 'Our locations',
    useMyLocation: 'Use my current location',
    detecting: 'Detecting...',
    directions: 'Directions',
    poweredBy: 'Powered by',
    mainBranch: 'Main',
    mondayFull: 'Monday', tuesdayFull: 'Tuesday', wednesdayFull: 'Wednesday', thursdayFull: 'Thursday', fridayFull: 'Friday', saturdayFull: 'Saturday', sundayFull: 'Sunday',
    geolocationNotSupported: 'Geolocation is not supported',
    locationDetected: 'Current location detected',
    locationError: 'Unable to detect your location',
    result: 'result',
    results: 'results',
    noResults: 'No results',
    inStock: 'in stock',
    selectOptionFirst: 'Select an option first',
    addNotes: 'Add notes to product',
  },
  es: {
    search: 'Buscar...',
    noProducts: 'No hay productos disponibles',
    articles: 'artículos',
    article: 'artículo',
    open: 'Abierto',
    closed: 'Cerrado',
    opensAt: 'Abre',
    openingHours: 'Horarios de apertura',
    addToCart: 'Añadir al carrito',
    viewCart: 'Ver carrito',
    order: 'Pedir',
    checkout: 'Pago',
    back: 'Volver',
    loading: 'Cargando...',
    storeNotFound: 'Tienda no encontrada',
    storeNotFoundDesc: 'Esta tienda no existe o ya no está disponible',
    delivery: 'Entrega',
    pickup: 'Recoger',
    dine_in: 'En el lugar',
    appointment: 'Cita',
    hotel: 'Reservación',
    other: 'Otros',
    added: 'añadido al carrito',
    howToOrder: '¿Cómo desea ordenar?',
    deliveryDesc: 'Reciba su pedido en casa',
    pickupDesc: 'Recoja en la tienda',
    dine_inDesc: 'Coma en el restaurante',
    appointmentDesc: 'Reserve su horario',
    hotelDesc: 'Reserve su estadía',
    outOfStock: 'Agotado',
    address: 'Dirección',
    defaultHeroText: 'Descubre nuestros productos y haz tu pedido', myCart: 'Mi carrito', emptyCart: 'Carrito vacío', addProductsStart: 'Añade productos para comenzar', proceedToCheckout: 'Ir a pagar', subtotal: 'Subtotal', mon: 'Lun', tue: 'Mar', wed: 'Mié', thu: 'Jue', fri: 'Vie', sat: 'Sáb', sun: 'Dom', selectOptions: 'Seleccione las opciones requeridas', contact: 'Contacto',
    categories: 'Categorías',
    quantity: 'Cantidad',
    required: 'Requerido',
    seeTranslation: 'Ver traducción',
    seeOriginal: 'Ver original',
    translating: 'Traduciendo...',
    ourAddress: 'Nuestra dirección',
    ourAddresses: 'Nuestras ubicaciones',
    useMyLocation: 'Usar mi ubicación actual',
    detecting: 'Detectando...',
    directions: 'Cómo llegar',
    poweredBy: 'Impulsado por',
    mainBranch: 'Principal',
    mondayFull: 'Lunes', tuesdayFull: 'Martes', wednesdayFull: 'Miércoles', thursdayFull: 'Jueves', fridayFull: 'Viernes', saturdayFull: 'Sábado', sundayFull: 'Domingo',
    geolocationNotSupported: 'La geolocalización no es compatible',
    locationDetected: 'Ubicación actual detectada',
    locationError: 'No se pudo detectar tu ubicación',
    result: 'resultado',
    results: 'resultados',
    noResults: 'Sin resultados',
    inStock: 'en stock',
    selectOptionFirst: 'Seleccione una opción primero',
    addNotes: 'Agregar notas al producto',
  },
  ar: {
    search: 'بحث...',
    noProducts: 'لا توجد منتجات',
    articles: 'منتجات',
    article: 'منتج',
    open: 'مفتوح',
    closed: 'مغلق',
    opensAt: 'يفتح',
    openingHours: 'ساعات العمل',
    addToCart: 'أضف إلى السلة',
    viewCart: 'عرض السلة',
    order: 'اطلب',
    checkout: 'الدفع',
    back: 'رجوع',
    loading: 'جاري التحميل...',
    storeNotFound: 'المتجر غير موجود',
    storeNotFoundDesc: 'هذا المتجر غير موجود أو لم يعد متاحًا',
    delivery: 'توصيل',
    pickup: 'استلام',
    dine_in: 'في المكان',
    appointment: 'موعد',
    hotel: 'حجز',
    other: 'أخرى',
    added: 'تمت الإضافة',
    howToOrder: 'كيف تريد الطلب؟',
    deliveryDesc: 'استلم طلبك في المنزل',
    pickupDesc: 'استلم من المتجر',
    dine_inDesc: 'تناول الطعام في المكان',
    appointmentDesc: 'احجز موعدك',
    hotelDesc: 'احجز إقامتك',
    outOfStock: 'غير متوفر',
    address: 'العنوان',
    defaultHeroText: 'اكتشف منتجاتنا وقدم طلبك', myCart: 'سلتي', emptyCart: 'السلة فارغة', addProductsStart: 'أضف منتجات للبدء', proceedToCheckout: 'المتابعة للدفع', subtotal: 'المجموع الفرعي', mon: 'إث', tue: 'ث', wed: 'أر', thu: 'خ', fri: 'ج', sat: 'س', sun: 'أح', selectOptions: 'اختر الخيارات المطلوبة', contact: 'اتصل',
    categories: 'الفئات',
    quantity: 'الكمية',
    required: 'مطلوب',
    seeTranslation: 'عرض الترجمة',
    seeOriginal: 'عرض الأصل',
    translating: 'جاري الترجمة...',
    ourAddress: 'عنواننا',
    ourAddresses: 'عناويننا',
    useMyLocation: 'استخدام موقعي الحالي',
    detecting: 'جاري الكشف...',
    directions: 'الاتجاهات',
    poweredBy: 'مدعوم من',
    mainBranch: 'رئيسي',
    mondayFull: 'الاثنين', tuesdayFull: 'الثلاثاء', wednesdayFull: 'الأربعاء', thursdayFull: 'الخميس', fridayFull: 'الجمعة', saturdayFull: 'السبت', sundayFull: 'الأحد',
    geolocationNotSupported: 'الموقع الجغرافي غير مدعوم',
    locationDetected: 'تم اكتشاف موقعك الحالي',
    locationError: 'تعذر اكتشاف موقعك',
    result: 'نتيجة',
    results: 'نتائج',
    noResults: 'لا توجد نتائج',
    inStock: 'متوفر',
    selectOptionFirst: 'اختر خيارًا أولاً',
    addNotes: 'إضافة ملاحظات للمنتج',
  },
  pt: {
    search: 'Pesquisar...',
    noProducts: 'Nenhum produto disponível',
    articles: 'artigos',
    article: 'artigo',
    open: 'Aberto',
    closed: 'Fechado',
    opensAt: 'Abre',
    openingHours: 'Horário de funcionamento',
    addToCart: 'Adicionar ao carrinho',
    viewCart: 'Ver carrinho',
    order: 'Pedir',
    checkout: 'Pagamento',
    back: 'Voltar',
    loading: 'Carregando...',
    storeNotFound: 'Loja não encontrada',
    storeNotFoundDesc: 'Esta loja não existe ou não está mais disponível',
    delivery: 'Entrega',
    pickup: 'Retirada',
    dine_in: 'No local',
    appointment: 'Agendamento',
    hotel: 'Reserva',
    other: 'Outros',
    added: 'adicionado ao carrinho',
    howToOrder: 'Como deseja pedir?',
    deliveryDesc: 'Receba seu pedido em casa',
    pickupDesc: 'Retire na loja',
    dine_inDesc: 'Coma no restaurante',
    appointmentDesc: 'Agende seu horário',
    hotelDesc: 'Reserve sua estadia',
    outOfStock: 'Esgotado',
    address: 'Endereço',
    defaultHeroText: 'Descubra nossos produtos e faça seu pedido', myCart: 'Meu carrinho', emptyCart: 'Carrinho vazio', addProductsStart: 'Adicione produtos para começar', proceedToCheckout: 'Finalizar compra', subtotal: 'Subtotal', mon: 'Seg', tue: 'Ter', wed: 'Qua', thu: 'Qui', fri: 'Sex', sat: 'Sáb', sun: 'Dom', selectOptions: 'Selecione as opções obrigatórias', contact: 'Contato',
    categories: 'Categorias',
    quantity: 'Quantidade',
    required: 'Obrigatório',
    seeTranslation: 'Ver tradução',
    seeOriginal: 'Ver original',
    translating: 'Traduzindo...',
    ourAddress: 'Nosso endereço',
    ourAddresses: 'Nossos endereços',
    useMyLocation: 'Usar minha localização atual',
    detecting: 'Detectando...',
    directions: 'Como chegar',
    poweredBy: 'Desenvolvido por',
    mainBranch: 'Principal',
    mondayFull: 'Segunda-feira', tuesdayFull: 'Terça-feira', wednesdayFull: 'Quarta-feira', thursdayFull: 'Quinta-feira', fridayFull: 'Sexta-feira', saturdayFull: 'Sábado', sundayFull: 'Domingo',
    geolocationNotSupported: 'Geolocalização não suportada',
    locationDetected: 'Localização atual detectada',
    locationError: 'Não foi possível detectar sua localização',
    result: 'resultado',
    results: 'resultados',
    noResults: 'Nenhum resultado',
    inStock: 'em estoque',
    selectOptionFirst: 'Selecione uma opção primeiro',
    addNotes: 'Adicionar notas ao produto',
  },
  de: {
    search: 'Suchen...',
    noProducts: 'Keine Produkte verfügbar',
    articles: 'Artikel',
    article: 'Artikel',
    open: 'Geöffnet',
    closed: 'Geschlossen',
    opensAt: 'Öffnet',
    openingHours: 'Öffnungszeiten',
    addToCart: 'In den Warenkorb',
    viewCart: 'Warenkorb ansehen',
    order: 'Bestellen',
    checkout: 'Kasse',
    back: 'Zurück',
    loading: 'Laden...',
    storeNotFound: 'Geschäft nicht gefunden',
    storeNotFoundDesc: 'Dieses Geschäft existiert nicht oder ist nicht mehr verfügbar',
    delivery: 'Lieferung',
    pickup: 'Abholung',
    dine_in: 'Vor Ort',
    appointment: 'Termin',
    hotel: 'Reservierung',
    other: 'Andere',
    added: 'zum Warenkorb hinzugefügt',
    howToOrder: 'Wie möchten Sie bestellen?',
    deliveryDesc: 'Lieferung nach Hause',
    pickupDesc: 'Abholung im Geschäft',
    dine_inDesc: 'Vor Ort essen',
    appointmentDesc: 'Termin buchen',
    hotelDesc: 'Aufenthalt buchen',
    outOfStock: 'Nicht vorrätig',
    address: 'Adresse',
    defaultHeroText: 'Entdecken Sie unsere Produkte und bestellen Sie', myCart: 'Mein Warenkorb', emptyCart: 'Warenkorb leer', addProductsStart: 'Fügen Sie Produkte hinzu', proceedToCheckout: 'Zur Kasse', subtotal: 'Zwischensumme', mon: 'Mo', tue: 'Di', wed: 'Mi', thu: 'Do', fri: 'Fr', sat: 'Sa', sun: 'So', selectOptions: 'Erforderliche Optionen auswählen', contact: 'Kontakt',
    categories: 'Kategorien',
    quantity: 'Menge',
    required: 'Erforderlich',
    seeTranslation: 'Übersetzung anzeigen',
    seeOriginal: 'Original anzeigen',
    translating: 'Übersetzen...',
    ourAddress: 'Unsere Adresse',
    ourAddresses: 'Unsere Standorte',
    useMyLocation: 'Meinen Standort verwenden',
    detecting: 'Wird erkannt...',
    directions: 'Wegbeschreibung',
    poweredBy: 'Betrieben von',
    mainBranch: 'Hauptsitz',
    mondayFull: 'Montag', tuesdayFull: 'Dienstag', wednesdayFull: 'Mittwoch', thursdayFull: 'Donnerstag', fridayFull: 'Freitag', saturdayFull: 'Samstag', sundayFull: 'Sonntag',
    geolocationNotSupported: 'Geolokalisierung wird nicht unterstützt',
    locationDetected: 'Aktueller Standort erkannt',
    locationError: 'Standort konnte nicht erkannt werden',
    result: 'Ergebnis',
    results: 'Ergebnisse',
    noResults: 'Keine Ergebnisse',
    inStock: 'auf Lager',
    selectOptionFirst: 'Wählen Sie zuerst eine Option',
    addNotes: 'Notizen zum Produkt hinzufügen',
  },
  wo: {
    search: 'Wut...',
    noProducts: 'Amul produit',
    articles: 'yoon',
    article: 'benn',
    open: 'Ubbi na',
    closed: 'Tëj na',
    opensAt: 'Dina ubbi',
    openingHours: 'Waxtu liggéey',
    addToCart: 'Yokk ci panier bi',
    viewCart: 'Xool panier bi',
    order: 'Commande',
    checkout: 'Fey',
    back: 'Dellu',
    loading: 'Yàgg nañu...',
    storeNotFound: 'Bitiig bi amul',
    storeNotFoundDesc: 'Bitiig bi amul walla daffa nëbb',
    delivery: 'Yóbbu',
    pickup: 'Jël',
    dine_in: 'Ci biir',
    appointment: 'Jotaay',
    hotel: 'Réservation',
    other: 'Yeneen',
    added: 'yokk na ci panier bi',
    howToOrder: 'Nan ngay bëgg di commande?',
    deliveryDesc: 'Yóbbu sa commande ca sa kër',
    pickupDesc: 'Jël ci bitiig bi',
    dine_inDesc: 'Lekk ci biir bi',
    appointmentDesc: 'Jël sa waxtu',
    hotelDesc: 'Réserve sa séjour',
    outOfStock: 'Jeex na',
    address: 'Adress',
    defaultHeroText: 'Séetal sunuy yeneen te ordone', myCart: 'Sama panier', emptyCart: 'Panier bi amul dara', addProductsStart: 'Yokk yeneen ngir door', proceedToCheckout: 'Fey', subtotal: 'Tollu ci suuf', mon: 'Alt', tue: 'Tal', wed: 'Àll', thu: 'Alx', fri: 'Àjj', sat: 'Gaw', sun: 'Dib', selectOptions: 'Tànn mbir yi warul', contact: 'Jokkoo',
    categories: 'Xeeti yi',
    quantity: 'Lim',
    required: 'Waru',
    seeTranslation: 'Xool tekki bi',
    seeOriginal: 'Xool bopp bi',
    translating: 'Yàgg nañu tekki...',
    ourAddress: 'Sunu adress',
    ourAddresses: 'Sunu adress yi',
    useMyLocation: 'Jëfandikool sama pozisiyoŋ',
    detecting: 'Yàgg nañu wut...',
    directions: 'Yoon wi',
    poweredBy: 'Jëfandikoo',
    mainBranch: 'Bopp',
    mondayFull: 'Altine', tuesdayFull: 'Talaata', wednesdayFull: 'Àllarba', thursdayFull: 'Alxames', fridayFull: 'Àjjuma', saturdayFull: 'Gaawu', sundayFull: 'Dibéer',
    geolocationNotSupported: 'Géolokalizasiyoŋ amul ci sa navigatër',
    locationDetected: 'Pozisiyoŋ bi am na ko',
    locationError: 'Mënuñu ko gis sa pozisiyoŋ',
    result: 'amal',
    results: 'amal yi',
    noResults: 'Amul amal',
    inStock: 'ci stock',
    selectOptionFirst: 'Tànn benn mbir ci njëk',
    addNotes: 'Yokk bindi ci bunt bi',
  },
  zh: {
    search: '搜索...',
    noProducts: '暂无产品',
    articles: '件商品',
    article: '件商品',
    open: '营业中',
    closed: '已关闭',
    opensAt: '开门时间',
    openingHours: '营业时间',
    addToCart: '加入购物车',
    viewCart: '查看购物车',
    order: '下单',
    checkout: '结账',
    back: '返回',
    loading: '加载中...',
    storeNotFound: '未找到店铺',
    storeNotFoundDesc: '该店铺不存在或已不可用',
    delivery: '配送',
    pickup: '自取',
    dine_in: '堂食',
    appointment: '预约',
    hotel: '预订',
    other: '其他',
    added: '已加入购物车',
    howToOrder: '您想如何下单？',
    deliveryDesc: '送货到家',
    pickupDesc: '到店自取',
    dine_inDesc: '在店用餐',
    appointmentDesc: '预约时间',
    hotelDesc: '预订住宿',
    outOfStock: '缺货',
    address: '地址',
    defaultHeroText: '发现我们的产品并下单', myCart: '我的购物车', emptyCart: '购物车为空', addProductsStart: '添加商品开始购物', proceedToCheckout: '去结账', subtotal: '小计', mon: '周一', tue: '周二', wed: '周三', thu: '周四', fri: '周五', sat: '周六', sun: '周日', selectOptions: '请选择必需选项', contact: '联系',
    categories: '分类',
    quantity: '数量',
    required: '必选',
    seeTranslation: '查看翻译',
    seeOriginal: '查看原文',
    translating: '翻译中...',
    ourAddress: '我们的地址',
    ourAddresses: '我们的位置',
    useMyLocation: '使用我的当前位置',
    detecting: '检测中...',
    directions: '路线',
    poweredBy: '技术支持',
    mainBranch: '总店',
    mondayFull: '星期一', tuesdayFull: '星期二', wednesdayFull: '星期三', thursdayFull: '星期四', fridayFull: '星期五', saturdayFull: '星期六', sundayFull: '星期日',
    geolocationNotSupported: '不支持地理定位',
    locationDetected: '已检测到当前位置',
    locationError: '无法检测您的位置',
    result: '个结果',
    results: '个结果',
    noResults: '没有结果',
    inStock: '有库存',
    selectOptionFirst: '请先选择一个选项',
    addNotes: '添加产品备注',
  },
  ru: {
    search: 'Поиск...',
    noProducts: 'Нет доступных товаров',
    articles: 'товаров',
    article: 'товар',
    open: 'Открыто',
    closed: 'Закрыто',
    opensAt: 'Откроется',
    openingHours: 'Часы работы',
    addToCart: 'В корзину',
    viewCart: 'Корзина',
    order: 'Заказать',
    checkout: 'Оплата',
    back: 'Назад',
    loading: 'Загрузка...',
    storeNotFound: 'Магазин не найден',
    storeNotFoundDesc: 'Этот магазин не существует или больше недоступен',
    delivery: 'Доставка',
    pickup: 'Самовывоз',
    dine_in: 'На месте',
    appointment: 'Запись',
    hotel: 'Бронирование',
    other: 'Другое',
    added: 'добавлено в корзину',
    howToOrder: 'Как вы хотите заказать?',
    deliveryDesc: 'Доставка на дом',
    pickupDesc: 'Забрать в магазине',
    dine_inDesc: 'Поесть на месте',
    appointmentDesc: 'Забронировать время',
    hotelDesc: 'Забронировать проживание',
    outOfStock: 'Нет в наличии',
    address: 'Адрес',
    defaultHeroText: 'Откройте наши продукты и сделайте заказ', myCart: 'Моя корзина', emptyCart: 'Корзина пуста', addProductsStart: 'Добавьте товары', proceedToCheckout: 'Оформить заказ', subtotal: 'Подитог', mon: 'Пн', tue: 'Вт', wed: 'Ср', thu: 'Чт', fri: 'Пт', sat: 'Сб', sun: 'Вс', selectOptions: 'Выберите обязательные опции', contact: 'Контакт',
    categories: 'Категории',
    quantity: 'Количество',
    required: 'Обязательно',
    seeTranslation: 'Показать перевод',
    seeOriginal: 'Показать оригинал',
    translating: 'Перевод...',
    ourAddress: 'Наш адрес',
    ourAddresses: 'Наши адреса',
    useMyLocation: 'Использовать моё местоположение',
    detecting: 'Определение...',
    directions: 'Маршрут',
    poweredBy: 'Работает на',
    mainBranch: 'Основной',
    mondayFull: 'Понедельник', tuesdayFull: 'Вторник', wednesdayFull: 'Среда', thursdayFull: 'Четверг', fridayFull: 'Пятница', saturdayFull: 'Суббота', sundayFull: 'Воскресенье',
    geolocationNotSupported: 'Геолокация не поддерживается',
    locationDetected: 'Текущее местоположение обнаружено',
    locationError: 'Не удалось определить местоположение',
    result: 'результат',
    results: 'результатов',
    noResults: 'Нет результатов',
    inStock: 'в наличии',
    selectOptionFirst: 'Сначала выберите опцию',
    addNotes: 'Добавить заметки к товару',
  },
  it: {
    search: 'Cerca...',
    noProducts: 'Nessun prodotto disponibile',
    articles: 'articoli',
    article: 'articolo',
    open: 'Aperto',
    closed: 'Chiuso',
    opensAt: 'Apre',
    openingHours: 'Orari di apertura',
    addToCart: 'Aggiungi al carrello',
    viewCart: 'Vedi carrello',
    order: 'Ordina',
    checkout: 'Pagamento',
    back: 'Indietro',
    loading: 'Caricamento...',
    storeNotFound: 'Negozio non trovato',
    storeNotFoundDesc: 'Questo negozio non esiste o non è più disponibile',
    delivery: 'Consegna',
    pickup: 'Asporto',
    dine_in: 'Sul posto',
    appointment: 'Appuntamento',
    hotel: 'Prenotazione',
    other: 'Altro',
    added: 'aggiunto al carrello',
    howToOrder: 'Come vuoi ordinare?',
    deliveryDesc: 'Ricevi a domicilio',
    pickupDesc: 'Ritira in negozio',
    dine_inDesc: 'Mangia sul posto',
    appointmentDesc: 'Prenota il tuo orario',
    hotelDesc: 'Prenota il soggiorno',
    outOfStock: 'Esaurito',
    address: 'Indirizzo',
    defaultHeroText: 'Scopri i nostri prodotti e ordina', myCart: 'Il mio carrello', emptyCart: 'Carrello vuoto', addProductsStart: 'Aggiungi prodotti per iniziare', proceedToCheckout: 'Vai alla cassa', subtotal: 'Subtotale', mon: 'Lun', tue: 'Mar', wed: 'Mer', thu: 'Gio', fri: 'Ven', sat: 'Sab', sun: 'Dom', selectOptions: 'Seleziona le opzioni richieste', contact: 'Contatto',
    categories: 'Categorie',
    quantity: 'Quantità',
    required: 'Obbligatorio',
    seeTranslation: 'Vedi traduzione',
    seeOriginal: 'Vedi originale',
    translating: 'Traduzione...',
    ourAddress: 'Il nostro indirizzo',
    ourAddresses: 'Le nostre sedi',
    useMyLocation: 'Usa la mia posizione attuale',
    detecting: 'Rilevamento...',
    directions: 'Indicazioni',
    poweredBy: 'Realizzato con',
    mainBranch: 'Principale',
    mondayFull: 'Lunedì', tuesdayFull: 'Martedì', wednesdayFull: 'Mercoledì', thursdayFull: 'Giovedì', fridayFull: 'Venerdì', saturdayFull: 'Sabato', sundayFull: 'Domenica',
    geolocationNotSupported: 'Geolocalizzazione non supportata',
    locationDetected: 'Posizione attuale rilevata',
    locationError: 'Impossibile rilevare la posizione',
    result: 'risultato',
    results: 'risultati',
    noResults: 'Nessun risultato',
    inStock: 'disponibile',
    selectOptionFirst: "Seleziona prima un'opzione",
    addNotes: 'Aggiungi note al prodotto',
  },
  ja: {
    search: '検索...',
    noProducts: '商品がありません',
    articles: '商品',
    article: '商品',
    open: '営業中',
    closed: '閉店',
    opensAt: '開店',
    openingHours: '営業時間',
    addToCart: 'カートに追加',
    viewCart: 'カートを見る',
    order: '注文',
    checkout: 'お会計',
    back: '戻る',
    loading: '読み込み中...',
    storeNotFound: '店舗が見つかりません',
    storeNotFoundDesc: 'この店舗は存在しないか、利用できなくなっています',
    delivery: '配達',
    pickup: 'テイクアウト',
    dine_in: '店内飲食',
    appointment: '予約',
    hotel: '宿泊予約',
    other: 'その他',
    added: 'カートに追加しました',
    howToOrder: 'ご注文方法をお選びください',
    deliveryDesc: 'ご自宅へお届け',
    pickupDesc: '店舗で受け取り',
    dine_inDesc: '店内でお食事',
    appointmentDesc: '時間を予約',
    hotelDesc: '宿泊を予約',
    outOfStock: '在庫切れ',
    address: '住所',
    defaultHeroText: '商品を見てご注文ください', myCart: 'カート', emptyCart: 'カートは空です', addProductsStart: '商品を追加してください', proceedToCheckout: 'レジに進む', subtotal: '小計', mon: '月', tue: '火', wed: '水', thu: '木', fri: '金', sat: '土', sun: '日', selectOptions: '必須オプションを選択', contact: '連絡先',
    categories: 'カテゴリー',
    quantity: '数量',
    required: '必須',
    seeTranslation: '翻訳を見る',
    seeOriginal: '原文を見る',
    translating: '翻訳中...',
    ourAddress: '当店の住所',
    ourAddresses: '店舗一覧',
    useMyLocation: '現在地を使用',
    detecting: '検出中...',
    directions: '道順',
    poweredBy: '提供元',
    mainBranch: '本店',
    mondayFull: '月曜日', tuesdayFull: '火曜日', wednesdayFull: '水曜日', thursdayFull: '木曜日', fridayFull: '金曜日', saturdayFull: '土曜日', sundayFull: '日曜日',
    geolocationNotSupported: '位置情報はサポートされていません',
    locationDetected: '現在地を検出しました',
    locationError: '位置を検出できません',
    result: '件の結果',
    results: '件の結果',
    noResults: '結果なし',
    inStock: '在庫あり',
    selectOptionFirst: '先にオプションを選択してください',
    addNotes: '商品にメモを追加',
  },
  ko: {
    search: '검색...',
    noProducts: '상품이 없습니다',
    articles: '개 상품',
    article: '개 상품',
    open: '영업 중',
    closed: '영업 종료',
    opensAt: '오픈',
    openingHours: '영업시간',
    addToCart: '장바구니에 추가',
    viewCart: '장바구니 보기',
    order: '주문',
    checkout: '결제',
    back: '뒤로',
    loading: '로딩 중...',
    storeNotFound: '매장을 찾을 수 없습니다',
    storeNotFoundDesc: '이 매장은 존재하지 않거나 더 이상 이용할 수 없습니다',
    delivery: '배달',
    pickup: '포장',
    dine_in: '매장식사',
    appointment: '예약',
    hotel: '숙박예약',
    other: '기타',
    added: '장바구니에 추가됨',
    howToOrder: '주문 방법을 선택하세요',
    deliveryDesc: '집으로 배달',
    pickupDesc: '매장에서 수령',
    dine_inDesc: '매장에서 식사',
    appointmentDesc: '시간 예약',
    hotelDesc: '숙박 예약',
    outOfStock: '품절',
    address: '주소',
    defaultHeroText: '제품을 둘러보고 주문하세요', myCart: '장바구니', emptyCart: '장바구니가 비어 있습니다', addProductsStart: '상품을 추가하세요', proceedToCheckout: '결제하기', subtotal: '소계', mon: '월', tue: '화', wed: '수', thu: '목', fri: '금', sat: '토', sun: '일', selectOptions: '필수 옵션을 선택하세요', contact: '연락처',
    categories: '카테고리',
    quantity: '수량',
    required: '필수',
    seeTranslation: '번역 보기',
    seeOriginal: '원문 보기',
    translating: '번역 중...',
    ourAddress: '우리 주소',
    ourAddresses: '매장 위치',
    useMyLocation: '내 현재 위치 사용',
    detecting: '감지 중...',
    directions: '길찾기',
    poweredBy: '제공',
    mainBranch: '본점',
    mondayFull: '월요일', tuesdayFull: '화요일', wednesdayFull: '수요일', thursdayFull: '목요일', fridayFull: '금요일', saturdayFull: '토요일', sundayFull: '일요일',
    geolocationNotSupported: '위치 서비스가 지원되지 않습니다',
    locationDetected: '현재 위치 감지됨',
    locationError: '위치를 감지할 수 없습니다',
    result: '개 결과',
    results: '개 결과',
    noResults: '결과 없음',
    inStock: '재고 있음',
    selectOptionFirst: '먼저 옵션을 선택하세요',
    addNotes: '상품에 메모 추가',
  },
  hi: {
    search: 'खोजें...',
    noProducts: 'कोई उत्पाद उपलब्ध नहीं',
    articles: 'उत्पाद',
    article: 'उत्पाद',
    open: 'खुला है',
    closed: 'बंद है',
    opensAt: 'खुलता है',
    openingHours: 'खुलने का समय',
    addToCart: 'कार्ट में जोड़ें',
    viewCart: 'कार्ट देखें',
    order: 'ऑर्डर करें',
    checkout: 'भुगतान',
    back: 'वापस',
    loading: 'लोड हो रहा है...',
    storeNotFound: 'दुकान नहीं मिली',
    storeNotFoundDesc: 'यह दुकान मौजूद नहीं है या अब उपलब्ध नहीं है',
    delivery: 'डिलीवरी',
    pickup: 'पिकअप',
    dine_in: 'अंदर खाएं',
    appointment: 'अपॉइंटमेंट',
    hotel: 'बुकिंग',
    other: 'अन्य',
    added: 'कार्ट में जोड़ा गया',
    howToOrder: 'आप कैसे ऑर्डर करना चाहते हैं?',
    deliveryDesc: 'घर पर डिलीवरी',
    pickupDesc: 'दुकान से उठाएं',
    dine_inDesc: 'अंदर बैठकर खाएं',
    appointmentDesc: 'अपना समय बुक करें',
    hotelDesc: 'अपना ठहराव बुक करें',
    outOfStock: 'स्टॉक में नहीं',
    address: 'पता',
    defaultHeroText: 'हमारे उत्पाद देखें और ऑर्डर करें', myCart: 'मेरा कार्ट', emptyCart: 'कार्ट खाली है', addProductsStart: 'उत्पाद जोड़ें', proceedToCheckout: 'चेकआउट करें', subtotal: 'उप-कुल', mon: 'सोम', tue: 'मंगल', wed: 'बुध', thu: 'गुरु', fri: 'शुक्र', sat: 'शनि', sun: 'रवि', selectOptions: 'आवश्यक विकल्प चुनें', contact: 'संपर्क',
    categories: 'श्रेणियाँ',
    quantity: 'मात्रा',
    required: 'आवश्यक',
    seeTranslation: 'अनुवाद देखें',
    seeOriginal: 'मूल देखें',
    translating: 'अनुवाद हो रहा है...',
    ourAddress: 'हमारा पता',
    ourAddresses: 'हमारे पते',
    useMyLocation: 'मेरा वर्तमान स्थान उपयोग करें',
    detecting: 'पता लगा रहे हैं...',
    directions: 'दिशा-निर्देश',
    poweredBy: 'द्वारा संचालित',
    mainBranch: 'मुख्य',
    mondayFull: 'सोमवार', tuesdayFull: 'मंगलवार', wednesdayFull: 'बुधवार', thursdayFull: 'गुरुवार', fridayFull: 'शुक्रवार', saturdayFull: 'शनिवार', sundayFull: 'रविवार',
    geolocationNotSupported: 'जियोलोकेशन समर्थित नहीं है',
    locationDetected: 'वर्तमान स्थान पता चला',
    locationError: 'आपका स्थान पता नहीं लगा सका',
    result: 'परिणाम',
    results: 'परिणाम',
    noResults: 'कोई परिणाम नहीं',
    inStock: 'स्टॉक में',
    selectOptionFirst: 'पहले एक विकल्प चुनें',
    addNotes: 'उत्पाद में नोट जोड़ें',
  },
  tr: {
    search: 'Ara...',
    noProducts: 'Ürün bulunamadı',
    articles: 'ürün',
    article: 'ürün',
    open: 'Açık',
    closed: 'Kapalı',
    opensAt: 'Açılış',
    openingHours: 'Çalışma saatleri',
    addToCart: 'Sepete ekle',
    viewCart: 'Sepeti gör',
    order: 'Sipariş ver',
    checkout: 'Ödeme',
    back: 'Geri',
    loading: 'Yükleniyor...',
    storeNotFound: 'Mağaza bulunamadı',
    storeNotFoundDesc: 'Bu mağaza mevcut değil veya artık kullanılamıyor',
    delivery: 'Teslimat',
    pickup: 'Gel al',
    dine_in: 'İçeride',
    appointment: 'Randevu',
    hotel: 'Rezervasyon',
    other: 'Diğer',
    added: 'sepete eklendi',
    howToOrder: 'Nasıl sipariş vermek istersiniz?',
    deliveryDesc: 'Eve teslimat',
    pickupDesc: 'Mağazadan al',
    dine_inDesc: 'İçeride yiyin',
    appointmentDesc: 'Randevu alın',
    hotelDesc: 'Konaklama rezervasyonu',
    outOfStock: 'Stokta yok',
    address: 'Adres',
    defaultHeroText: 'Ürünlerimizi keşfedin ve sipariş verin', myCart: 'Sepetim', emptyCart: 'Sepet boş', addProductsStart: 'Ürün ekleyin', proceedToCheckout: 'Ödemeye geç', subtotal: 'Ara toplam', mon: 'Pzt', tue: 'Sal', wed: 'Çar', thu: 'Per', fri: 'Cum', sat: 'Cmt', sun: 'Paz', selectOptions: 'Gerekli seçenekleri seçin', contact: 'İletişim',
    categories: 'Kategoriler',
    quantity: 'Miktar',
    required: 'Gerekli',
    seeTranslation: 'Çeviriyi gör',
    seeOriginal: 'Orijinali gör',
    translating: 'Çevriliyor...',
    ourAddress: 'Adresimiz',
    ourAddresses: 'Konumlarımız',
    useMyLocation: 'Mevcut konumumu kullan',
    detecting: 'Tespit ediliyor...',
    directions: 'Yol tarifi',
    poweredBy: 'Altyapı',
    mainBranch: 'Ana',
    mondayFull: 'Pazartesi', tuesdayFull: 'Salı', wednesdayFull: 'Çarşamba', thursdayFull: 'Perşembe', fridayFull: 'Cuma', saturdayFull: 'Cumartesi', sundayFull: 'Pazar',
    geolocationNotSupported: 'Konum hizmeti desteklenmiyor',
    locationDetected: 'Mevcut konum tespit edildi',
    locationError: 'Konumunuz tespit edilemedi',
    result: 'sonuç',
    results: 'sonuç',
    noResults: 'Sonuç bulunamadı',
    inStock: 'stokta',
    selectOptionFirst: 'Önce bir seçenek belirleyin',
    addNotes: 'Ürüne not ekle',
  },
  nl: {
    search: 'Zoeken...',
    noProducts: 'Geen producten beschikbaar',
    articles: 'artikelen',
    article: 'artikel',
    open: 'Open',
    closed: 'Gesloten',
    opensAt: 'Opent',
    openingHours: 'Openingstijden',
    addToCart: 'In winkelwagen',
    viewCart: 'Winkelwagen',
    order: 'Bestellen',
    checkout: 'Afrekenen',
    back: 'Terug',
    loading: 'Laden...',
    storeNotFound: 'Winkel niet gevonden',
    storeNotFoundDesc: 'Deze winkel bestaat niet of is niet meer beschikbaar',
    delivery: 'Bezorging',
    pickup: 'Afhalen',
    dine_in: 'Ter plaatse',
    appointment: 'Afspraak',
    hotel: 'Reservering',
    other: 'Overig',
    added: 'toegevoegd aan winkelwagen',
    howToOrder: 'Hoe wilt u bestellen?',
    deliveryDesc: 'Laat thuis bezorgen',
    pickupDesc: 'Ophalen in de winkel',
    dine_inDesc: 'Ter plaatse eten',
    appointmentDesc: 'Maak een afspraak',
    hotelDesc: 'Boek uw verblijf',
    outOfStock: 'Niet op voorraad',
    address: 'Adres',
    defaultHeroText: 'Ontdek onze producten en plaats uw bestelling', myCart: 'Mijn winkelwagen', emptyCart: 'Winkelwagen is leeg', addProductsStart: 'Voeg producten toe', proceedToCheckout: 'Afrekenen', subtotal: 'Subtotaal', mon: 'Ma', tue: 'Di', wed: 'Wo', thu: 'Do', fri: 'Vr', sat: 'Za', sun: 'Zo', selectOptions: 'Selecteer vereiste opties', contact: 'Contact',
    categories: 'Categorieën',
    quantity: 'Aantal',
    required: 'Vereist',
    seeTranslation: 'Vertaling bekijken',
    seeOriginal: 'Origineel bekijken',
    translating: 'Vertalen...',
    ourAddress: 'Ons adres',
    ourAddresses: 'Onze locaties',
    useMyLocation: 'Mijn huidige locatie gebruiken',
    detecting: 'Detecteren...',
    directions: 'Routebeschrijving',
    poweredBy: 'Mogelijk gemaakt door',
    mainBranch: 'Hoofd',
    mondayFull: 'Maandag', tuesdayFull: 'Dinsdag', wednesdayFull: 'Woensdag', thursdayFull: 'Donderdag', fridayFull: 'Vrijdag', saturdayFull: 'Zaterdag', sundayFull: 'Zondag',
    geolocationNotSupported: 'Geolocatie wordt niet ondersteund',
    locationDetected: 'Huidige locatie gedetecteerd',
    locationError: 'Kan uw locatie niet detecteren',
    result: 'resultaat',
    results: 'resultaten',
    noResults: 'Geen resultaten',
    inStock: 'op voorraad',
    selectOptionFirst: 'Selecteer eerst een optie',
    addNotes: 'Notities toevoegen aan product',
  },
  pl: {
    search: 'Szukaj...',
    noProducts: 'Brak dostępnych produktów',
    articles: 'produktów',
    article: 'produkt',
    open: 'Otwarte',
    closed: 'Zamknięte',
    opensAt: 'Otwiera',
    openingHours: 'Godziny otwarcia',
    addToCart: 'Dodaj do koszyka',
    viewCart: 'Koszyk',
    order: 'Zamów',
    checkout: 'Płatność',
    back: 'Wstecz',
    loading: 'Ładowanie...',
    storeNotFound: 'Sklep nie znaleziony',
    storeNotFoundDesc: 'Ten sklep nie istnieje lub nie jest już dostępny',
    delivery: 'Dostawa',
    pickup: 'Odbiór',
    dine_in: 'Na miejscu',
    appointment: 'Wizyta',
    hotel: 'Rezerwacja',
    other: 'Inne',
    added: 'dodano do koszyka',
    howToOrder: 'Jak chcesz zamówić?',
    deliveryDesc: 'Dostawa do domu',
    pickupDesc: 'Odbiór w sklepie',
    dine_inDesc: 'Jedzenie na miejscu',
    appointmentDesc: 'Zarezerwuj wizytę',
    hotelDesc: 'Zarezerwuj pobyt',
    outOfStock: 'Brak w magazynie',
    address: 'Adres',
    defaultHeroText: 'Odkryj nasze produkty i złóż zamówienie', myCart: 'Mój koszyk', emptyCart: 'Koszyk jest pusty', addProductsStart: 'Dodaj produkty', proceedToCheckout: 'Do kasy', subtotal: 'Suma częściowa', mon: 'Pon', tue: 'Wt', wed: 'Śr', thu: 'Czw', fri: 'Pt', sat: 'Sob', sun: 'Ndz', selectOptions: 'Wybierz wymagane opcje', contact: 'Kontakt',
    categories: 'Kategorie',
    quantity: 'Ilość',
    required: 'Wymagane',
    seeTranslation: 'Zobacz tłumaczenie',
    seeOriginal: 'Zobacz oryginał',
    translating: 'Tłumaczenie...',
    ourAddress: 'Nasz adres',
    ourAddresses: 'Nasze lokalizacje',
    useMyLocation: 'Użyj mojej aktualnej lokalizacji',
    detecting: 'Wykrywanie...',
    directions: 'Wskazówki dojazdu',
    poweredBy: 'Obsługiwane przez',
    mainBranch: 'Główna',
    mondayFull: 'Poniedziałek', tuesdayFull: 'Wtorek', wednesdayFull: 'Środa', thursdayFull: 'Czwartek', fridayFull: 'Piątek', saturdayFull: 'Sobota', sundayFull: 'Niedziela',
    geolocationNotSupported: 'Geolokalizacja nie jest obsługiwana',
    locationDetected: 'Wykryto bieżącą lokalizację',
    locationError: 'Nie można wykryć Twojej lokalizacji',
    result: 'wynik',
    results: 'wyników',
    noResults: 'Brak wyników',
    inStock: 'w magazynie',
    selectOptionFirst: 'Najpierw wybierz opcję',
    addNotes: 'Dodaj uwagi do produktu',
  },
  sw: {
    search: 'Tafuta...',
    noProducts: 'Hakuna bidhaa',
    articles: 'bidhaa',
    article: 'bidhaa',
    open: 'Wazi',
    closed: 'Imefungwa',
    opensAt: 'Inafunguka',
    openingHours: 'Saa za kufungua',
    addToCart: 'Ongeza kwenye kikapu',
    viewCart: 'Tazama kikapu',
    order: 'Agiza',
    checkout: 'Lipa',
    back: 'Rudi',
    loading: 'Inapakia...',
    storeNotFound: 'Duka halipatikani',
    storeNotFoundDesc: 'Duka hili halipo au halipatikani tena',
    delivery: 'Uwasilishaji',
    pickup: 'Kuchukua',
    dine_in: 'Kula hapa',
    appointment: 'Miadi',
    hotel: 'Uhifadhi',
    other: 'Nyingine',
    added: 'imeongezwa kwenye kikapu',
    howToOrder: 'Unataka kuagiza vipi?',
    deliveryDesc: 'Pata agizo nyumbani',
    pickupDesc: 'Chukua dukani',
    dine_inDesc: 'Kula ndani',
    appointmentDesc: 'Weka miadi yako',
    hotelDesc: 'Hifadhi kukaa kwako',
    outOfStock: 'Imeisha',
    address: 'Anwani',
    defaultHeroText: 'Gundua bidhaa zetu na agiza', myCart: 'Kikapu changu', emptyCart: 'Kikapu ni tupu', addProductsStart: 'Ongeza bidhaa kuanza', proceedToCheckout: 'Endelea kulipa', subtotal: 'Jumla ndogo', mon: 'Jtt', tue: 'Jnn', wed: 'Jtn', thu: 'Alh', fri: 'Iju', sat: 'Jmt', sun: 'Jpi', selectOptions: 'Chagua chaguo zinazohitajika', contact: 'Mawasiliano',
    categories: 'Makundi',
    quantity: 'Kiasi',
    required: 'Lazima',
    seeTranslation: 'Ona tafsiri',
    seeOriginal: 'Ona asili',
    translating: 'Inatafsiri...',
    ourAddress: 'Anwani yetu',
    ourAddresses: 'Maeneo yetu',
    useMyLocation: 'Tumia eneo langu la sasa',
    detecting: 'Inatambua...',
    directions: 'Maelekezo',
    poweredBy: 'Imetengenezwa na',
    mainBranch: 'Kuu',
    mondayFull: 'Jumatatu', tuesdayFull: 'Jumanne', wednesdayFull: 'Jumatano', thursdayFull: 'Alhamisi', fridayFull: 'Ijumaa', saturdayFull: 'Jumamosi', sundayFull: 'Jumapili',
    geolocationNotSupported: 'Huduma ya eneo haitumiki',
    locationDetected: 'Eneo la sasa limetambuliwa',
    locationError: 'Haiwezekani kutambua eneo lako',
    result: 'tokeo',
    results: 'matokeo',
    noResults: 'Hakuna matokeo',
    inStock: 'ipo',
    selectOptionFirst: 'Chagua chaguo kwanza',
    addNotes: 'Ongeza maelezo kwa bidhaa',
  },
  ha: {
    search: 'Nema...',
    noProducts: 'Babu kaya',
    articles: 'kayayyaki',
    article: 'kaya',
    open: 'A buɗe',
    closed: 'A rufe',
    opensAt: 'Za a buɗe',
    openingHours: 'Lokacin buɗewa',
    addToCart: 'Saka cikin kwandon',
    viewCart: 'Duba kwandon',
    order: 'Yi oda',
    checkout: 'Biya',
    back: 'Komawa',
    loading: 'Ana lodawa...',
    storeNotFound: 'Ba a sami shago ba',
    storeNotFoundDesc: 'Wannan shago ba ya nan ko kuma ba a iya samun sa',
    delivery: 'Isarwa',
    pickup: 'Ɗauka',
    dine_in: 'Ci a nan',
    appointment: 'Alƙawari',
    hotel: 'Ajiye ɗaki',
    other: 'Wani',
    added: 'an saka cikin kwandon',
    howToOrder: 'Yaya kake so ka yi oda?',
    deliveryDesc: 'A kawo maka gida',
    pickupDesc: 'Ɗauka a shago',
    dine_inDesc: 'Ci a cikin shago',
    appointmentDesc: 'Yi alƙawarin lokaci',
    hotelDesc: 'Ajiye masauki',
    outOfStock: 'Ya ƙare',
    address: 'Adireshi',
    defaultHeroText: 'Gano kayayyakinmu kuma ku yi oda', myCart: 'Kwandon ni', emptyCart: 'Kwandon babu komai', addProductsStart: 'Ƙara kaya don fara', proceedToCheckout: 'Ci gaba da biya', subtotal: 'Jimlar ƙasa', mon: 'Lit', tue: 'Tal', wed: 'Lar', thu: 'Alh', fri: 'Jum', sat: 'Asa', sun: 'Lah', selectOptions: 'Zaɓi abubuwan da ake buƙata', contact: 'Tuntuɓi',
    categories: 'Rukunoni',
    quantity: 'Yawa',
    required: 'Dole ne',
    seeTranslation: 'Duba fassara',
    seeOriginal: 'Duba asali',
    translating: 'Ana fassara...',
    ourAddress: 'Adireshinmu',
    ourAddresses: 'Wuraren mu',
    useMyLocation: 'Yi amfani da inda nake yanzu',
    detecting: 'Ana gano...',
    directions: 'Jagora',
    poweredBy: 'Ta hanyar',
    mainBranch: 'Babba',
    mondayFull: 'Litinin', tuesdayFull: 'Talata', wednesdayFull: 'Laraba', thursdayFull: 'Alhamis', fridayFull: 'Jumma\'a', saturdayFull: 'Asabar', sundayFull: 'Lahadi',
    geolocationNotSupported: 'Ba a iya amfani da wuri ba',
    locationDetected: 'An gano inda kake',
    locationError: 'Ba a iya gano wurin da kake ba',
    result: 'sakamako',
    results: 'sakamako',
    noResults: 'Babu sakamako',
    inStock: 'akwai',
    selectOptionFirst: 'Fara zaɓi wani zaɓi',
    addNotes: 'Ƙara bayani ga kaya',
  },
  yo: {
    search: 'Wa...',
    noProducts: 'Ko si ọja',
    articles: 'ọja',
    article: 'ọja',
    open: 'Ṣí',
    closed: 'Ti pa',
    opensAt: 'Yoo ṣí',
    openingHours: 'Akoko ṣíṣí',
    addToCart: 'Fi si agbọn',
    viewCart: 'Wo agbọn',
    order: 'Paṣẹ',
    checkout: 'Sanwo',
    back: 'Padà',
    loading: 'N ṣe ẹru...',
    storeNotFound: 'Ko ri ile-itaja',
    storeNotFoundDesc: 'Ile-itaja yii ko si tabi ko si mọ',
    delivery: 'Ifiranṣẹ',
    pickup: 'Gbà',
    dine_in: 'Jẹ nibi',
    appointment: 'Ipade',
    hotel: 'Ibi-isimi',
    other: 'Miran',
    added: 'ti fi si agbọn',
    howToOrder: 'Bawo ni o ṣe fẹ paṣẹ?',
    deliveryDesc: 'Gba ni ile rẹ',
    pickupDesc: 'Gbà ni ile-itaja',
    dine_inDesc: 'Jẹun nibi',
    appointmentDesc: 'Yan akoko rẹ',
    hotelDesc: 'Yan ibi-isimi',
    outOfStock: 'Ti pari',
    address: 'Adirẹsi',
    defaultHeroText: 'Ṣàwárí àwọn ọjà wa kí o sì gbé àṣẹ', myCart: 'Agbọn mi', emptyCart: 'Agbọn ṣòfò', addProductsStart: 'Fi ọjà kun lati bẹrẹ', proceedToCheckout: 'Tẹ̀síwájú sí ìsanwó', subtotal: 'Àpapọ̀ kékeré', mon: 'Ajé', tue: 'Ìṣẹ́', wed: 'Ọjọ́', thu: 'Ọjọ́', fri: 'Ẹtì', sat: 'Àbá', sun: 'Àìk', selectOptions: 'Yan àwọn àṣàyàn tí a nílò', contact: 'Kàn sí',
    categories: 'Ẹ̀ka',
    quantity: 'Iye',
    required: 'Nílò',
    seeTranslation: 'Wo ìtumọ̀',
    seeOriginal: 'Wo àkọ́kọ́',
    translating: 'Ń túmọ̀...',
    ourAddress: 'Àdírẹ́sì wa',
    ourAddresses: 'Àwọn ibi wa',
    useMyLocation: 'Lo ibi tí mo wà',
    detecting: 'Ń wá...',
    directions: 'Ìtọ́sọ́nà',
    poweredBy: 'Pẹ̀lú',
    mainBranch: 'Àkọ́kọ́',
    mondayFull: 'Ọjọ́ Ajé', tuesdayFull: 'Ọjọ́ Ìṣẹ́gun', wednesdayFull: 'Ọjọ́rú', thursdayFull: 'Ọjọ́bọ̀', fridayFull: 'Ọjọ́ Ẹtì', saturdayFull: 'Ọjọ́ Àbámẹ́ta', sundayFull: 'Ọjọ́ Àìkú',
    geolocationNotSupported: 'Iṣẹ́ ìpò kò ṣiṣẹ́',
    locationDetected: 'A ti rí ibi tí o wà',
    locationError: 'A kò lè rí ibi tí o wà',
    result: 'àbájáde',
    results: 'àbájáde',
    noResults: 'Kò sí àbájáde',
    inStock: 'ní ọjà',
    selectOptionFirst: 'Yan àṣàyàn kan lákọ̀ọ́kọ́',
    addNotes: 'Fi àkọsílẹ̀ kun ọjà',
  },
  ig: {
    search: 'Chọọ...',
    noProducts: 'Enweghị ngwa ahịa',
    articles: 'ngwa ahịa',
    article: 'ngwa ahịa',
    open: 'Mepere',
    closed: 'Mechiri',
    opensAt: 'Ga-emepe',
    openingHours: 'Oge mmeghe',
    addToCart: 'Tinye na ngwa',
    viewCart: 'Lee ngwa',
    order: 'Nye iwu',
    checkout: 'Kwụọ ụgwọ',
    back: 'Laghachi',
    loading: 'Na-ebu...',
    storeNotFound: 'Ahụghị ụlọ ahịa',
    storeNotFoundDesc: 'Ụlọ ahịa a adịghị ma ọ bụ enweghịzi ya',
    delivery: 'Nbufe',
    pickup: 'Wepụta',
    dine_in: 'Rie ebe a',
    appointment: 'Nzukọ',
    hotel: 'Nchekwa',
    other: 'Ndị ọzọ',
    added: 'etinyere na ngwa',
    howToOrder: 'Kedu ka ị chọrọ isi nye iwu?',
    deliveryDesc: 'Nata na ụlọ gị',
    pickupDesc: 'Wepụta na ụlọ ahịa',
    dine_inDesc: 'Rie n\'ime ụlọ ahịa',
    appointmentDesc: 'Họrọ oge gị',
    hotelDesc: 'Chekwaa ọnọdụ gị',
    outOfStock: 'Agwụla',
    address: 'Adreesị',
    defaultHeroText: 'Chọpụta ngwaahịa anyị wee nye iwu', myCart: 'Ụgbọ m', emptyCart: 'Ụgbọ tọgbọrọ', addProductsStart: 'Tinye ngwaahịa iji malite', proceedToCheckout: 'Gaa n\'ihu ịkwụ ụgwọ', subtotal: 'Subtotal', mon: 'Mọn', tue: 'Tuz', wed: 'Wen', thu: 'Tọz', fri: 'Fra', sat: 'Sat', sun: 'Ụka', selectOptions: 'Họrọ nhọrọ achọrọ', contact: 'Kpọtụrụ',
    categories: 'Udi',
    quantity: 'Ọnụ ọgụgụ',
    required: 'Achọrọ',
    seeTranslation: 'Lee ntụgharị',
    seeOriginal: 'Lee nke mbụ',
    translating: 'Na-atụgharị...',
    ourAddress: 'Adreesị anyị',
    ourAddresses: 'Ebe anyị nọ',
    useMyLocation: 'Jiri ebe m nọ ugbu a',
    detecting: 'Na-achọ...',
    directions: 'Ntụzịaka',
    poweredBy: 'Nke',
    mainBranch: 'Isi',
    mondayFull: 'Mọnde', tuesdayFull: 'Tuzdee', wednesdayFull: 'Wenezdee', thursdayFull: 'Tọzdee', fridayFull: 'Fraịdee', saturdayFull: 'Satọdee', sundayFull: 'Ụka',
    geolocationNotSupported: 'Ọnọdụ agaghị arụ ọrụ',
    locationDetected: 'Achọpụtara ebe ị nọ',
    locationError: 'Enweghị ike ịchọpụta ebe ị nọ',
    result: 'nsoputạ',
    results: 'nsoputạ',
    noResults: 'Ọ nweghị nsoputạ',
    inStock: 'dị na stock',
    selectOptionFirst: 'Họrọ nhọrọ na mbụ',
    addNotes: 'Tinye ndetu na ngwaahịa',
  },
  am: {
    search: 'ፈልግ...',
    noProducts: 'ምንም ምርት የለም',
    articles: 'ምርቶች',
    article: 'ምርት',
    open: 'ክፍት',
    closed: 'ዝግ',
    opensAt: 'ይከፈታል',
    openingHours: 'የስራ ሰዓት',
    addToCart: 'ወደ ጋሪ ጨምር',
    viewCart: 'ጋሪ ተመልከት',
    order: 'ኦርደር',
    checkout: 'ክፍያ',
    back: 'ተመለስ',
    loading: 'በመጫን ላይ...',
    storeNotFound: 'ሱቅ አልተገኘም',
    storeNotFoundDesc: 'ይህ ሱቅ የለም ወይም ከአሁን በኋላ አይገኝም',
    delivery: 'ማድረስ',
    pickup: 'መውሰድ',
    dine_in: 'እዚህ ይበሉ',
    appointment: 'ቀጠሮ',
    hotel: 'ቦታ ማስያዝ',
    other: 'ሌላ',
    added: 'ወደ ጋሪ ተጨምሯል',
    howToOrder: 'እንዴት ማዘዝ ይፈልጋሉ?',
    deliveryDesc: 'ወደ ቤትዎ ይላካል',
    pickupDesc: 'ከሱቅ ይውሰዱ',
    dine_inDesc: 'በሱቅ ውስጥ ይበሉ',
    appointmentDesc: 'ሰዓትዎን ይያዙ',
    hotelDesc: 'ማረፊያ ይያዙ',
    outOfStock: 'አልቋል',
    address: 'አድራሻ',
    defaultHeroText: 'ምርቶቻችንን ያግኙ እና ያዝዙ', myCart: 'ጋሪዬ', emptyCart: 'ጋሪ ባዶ ነው', addProductsStart: 'ምርቶች ይጨምሩ', proceedToCheckout: 'ወደ ክፍያ ቀጥል', subtotal: 'ንዑስ ድምር', mon: 'ሰኞ', tue: 'ማክ', wed: 'ረቡ', thu: 'ሐሙ', fri: 'ዓርብ', sat: 'ቅዳ', sun: 'እሑድ', selectOptions: 'አስፈላጊ አማራጮችን ይምረጡ', contact: 'እውቂያ',
    categories: 'ምድቦች',
    quantity: 'ብዛት',
    required: 'ያስፈልጋል',
    seeTranslation: 'ትርጉም ይመልከቱ',
    seeOriginal: 'ዋናውን ይመልከቱ',
    translating: 'በመተርጎም ላይ...',
    ourAddress: 'አድራሻችን',
    ourAddresses: 'ቦታዎቻችን',
    useMyLocation: 'የአሁኑን ቦታዬን ተጠቀም',
    detecting: 'በመፈለግ ላይ...',
    directions: 'አቅጣጫ',
    poweredBy: 'በ',
    mainBranch: 'ዋና',
    mondayFull: 'ሰኞ', tuesdayFull: 'ማክሰኞ', wednesdayFull: 'ረቡዕ', thursdayFull: 'ሐሙስ', fridayFull: 'ዓርብ', saturdayFull: 'ቅዳሜ', sundayFull: 'እሑድ',
    geolocationNotSupported: 'የጂኦሎኬሽን አገልግሎት አይደገፍም',
    locationDetected: 'የአሁኑ ቦታ ተገኝቷል',
    locationError: 'ቦታዎን ማግኘት አልተቻለም',
    result: 'ውጤት',
    results: 'ውጤቶች',
    noResults: 'ምንም ውጤት የለም',
    inStock: 'አለ',
    selectOptionFirst: 'መጀመሪያ አማራጭ ይምረጡ',
    addNotes: 'ለምርቱ ማስታወሻ ያክሉ',
  },
  zu: {
    search: 'Sesha...',
    noProducts: 'Awekho imikhiqizo',
    articles: 'imikhiqizo',
    article: 'umkhiqizo',
    open: 'Kuvuliwe',
    closed: 'Kuvalwe',
    opensAt: 'Kuvulwa',
    openingHours: 'Amahora okuvula',
    addToCart: 'Faka ebhasikidini',
    viewCart: 'Buka ibhasikidi',
    order: 'Oda',
    checkout: 'Khokha',
    back: 'Emuva',
    loading: 'Iyalayisha...',
    storeNotFound: 'Isitolo asitholakali',
    storeNotFoundDesc: 'Lesi sitolo asikho noma asisatholakali',
    delivery: 'Ukuhanjiswa',
    pickup: 'Ukuthatha',
    dine_in: 'Dlela lapha',
    appointment: 'Isikhathi',
    hotel: 'Ukubhuka',
    other: 'Okunye',
    added: 'kungezwe ebhasikidini',
    howToOrder: 'Ufuna ukuoda kanjani?',
    deliveryDesc: 'Lethwa ekhaya',
    pickupDesc: 'Thatha esitolo',
    dine_inDesc: 'Dlela ngaphakathi',
    appointmentDesc: 'Beka isikhathi sakho',
    hotelDesc: 'Beka indawo yakho',
    outOfStock: 'Kuphelile',
    address: 'Ikheli',
    defaultHeroText: 'Thola imikhiqizo yethu bese u-odela', myCart: 'Inqola yami', emptyCart: 'Inqola ayinalutho', addProductsStart: 'Engeza imikhiqizo ukuqala', proceedToCheckout: 'Qhubeka nokukhokha', subtotal: 'Isisekelo', mon: 'Mso', tue: 'Bil', wed: 'Tha', thu: 'Sin', fri: 'Hla', sat: 'Mgq', sun: 'Son', selectOptions: 'Khetha izinketho ezidingekayo', contact: 'Xhumana',
    categories: 'Izigaba',
    quantity: 'Ubuningi',
    required: 'Kufanele',
    seeTranslation: 'Bona ukuhumusha',
    seeOriginal: 'Bona okokuqala',
    translating: 'Iyahumusha...',
    ourAddress: 'Ikheli lethu',
    ourAddresses: 'Izindawo zethu',
    useMyLocation: 'Sebenzisa indawo yami yamanje',
    detecting: 'Ithola...',
    directions: 'Izikhombiso zendlela',
    poweredBy: 'Kusetshenziswa',
    mainBranch: 'Okuyinhloko',
    mondayFull: 'UMsombuluko', tuesdayFull: 'ULwesibili', wednesdayFull: 'ULwesithathu', thursdayFull: 'ULwesine', fridayFull: 'ULwesihlanu', saturdayFull: 'UMgqibelo', sundayFull: 'ISonto',
    geolocationNotSupported: 'I-geolocation ayisekelwa',
    locationDetected: 'Indawo yamanje itholakele',
    locationError: 'Ayikwazi ukuthola indawo yakho',
    result: 'umphumela',
    results: 'imiphumela',
    noResults: 'Ayikho imiphumela',
    inStock: 'iyatholakala',
    selectOptionFirst: 'Khetha inketho kuqala',
    addNotes: 'Engeza amanothi kumkhiqizo',
  },
};

export const getStorefrontLabels = (lang = 'fr') => labels[lang] || labels.fr;
